module.exports = __webpack_public_path__ + "static/media/Ciantera-Rose.90024834.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ciantera-Rose.jpeg
// module id = 178
// module chunks = 0